import { AuthMutation } from "../types";

export default {
  [AuthMutation.SET_USER](state: any, payload: any) {
    state.user = payload;
  },
  [AuthMutation.CLEAR_USER](state: any) {
    state.user = {};
  },
  [AuthMutation.SET_DEVICE_ID](state: any, payload: any) {
    state.deviceId = payload;
  },
  [AuthMutation.SET_TENANT_CD](state: any, payload: any) {
    state.tenantCode = payload;
  },
  [AuthMutation.SET_STAFF](state: any, payload: any) {
    state.staff = payload;
  },
  [AuthMutation.SET_LAST_LOGIN_DATETIME](state: any, payload: any) {
    state.lastLoginDateTime = payload;
  },
  [AuthMutation.SET_GUEST](state: any, payload: any) {
    state.guest = payload;
  },
  [AuthMutation.CLEAR_GUEST](state: any) {
    state.guest = {};
  },
  [AuthMutation.LOGOUT](state: any) {
    // 通知するだけ
  },
  [AuthMutation.SET_IS_USER_LOGGED_OUT](state: any, payload: boolean) {
    state.isUserLoggedOut = payload;
  },
  [AuthMutation.SET_ONE_TIME_TOKEN](state: any, payload: string) {
    state.oneTimeToken = payload;
  },
  [AuthMutation.SET_USER_AGENT](state: any, payload: string) {
    state.userAgent = payload;
  },
  [AuthMutation.SET_SUBSCRIPTION_ENDPOINT](state: any, payload: string) {
    state.subscriptionEndpoint = payload;
  },
  [AuthMutation.SET_ACCESS_TOKEN](state: any, payload: string) {
    state.accessToken = payload;
  },
  [AuthMutation.SET_REFRESH_TOKEN](state: any, payload: string) {
    state.refreshToken = payload;
  },
};
